import { render, staticRenderFns } from "./ProjectTaskUtilizationChart.vue?vue&type=template&id=6a105157"
import script from "./ProjectTaskUtilizationChart.vue?vue&type=script&lang=js"
export * from "./ProjectTaskUtilizationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports